import Phaser from 'phaser'
import ScoreLabel from '../ui/ScoreLabel'
import LifeLabel from '../ui/LifeLabel.js'
export default class MathScene extends
    Phaser.Scene {
    constructor() {
        super('soal-scene')
    }

    init(data) {

        this.gameHalfWidth = this.scale.width * 0.5
        this.gameHalfHeight = this.scale.height * 0.5

        this.player = undefined
        this.enemy = undefined

        this.questionText = undefined
        this.resultText = undefined

        this.button1 = undefined
        this.button2 = undefined
        this.button3 = undefined
        this.button4 = undefined
        this.button5 = undefined
        this.button6 = undefined
        this.button7 = undefined
        this.button8 = undefined
        this.button9 = undefined
        this.button0 = undefined
        this.buttonDel = undefined
        this.buttonOk = undefined

        this.numberArray = []
        this.number = 0

        this.question = []

        this.correctAnswer = undefined

        this.scoreLabel = undefined
        this.score = data.score

        this.lifeLabel = data.lifeLabel ? data.lifeLabel : 0

        this.totalEnemy = data.totalEnemy

        this.enemyArray = []
        this.enemyArray = data.enemyArray

        this.timerLabel = undefined
        this.countdownTimer = 10
        this.timedEvent = undefined

        this.playerCoordinate = data.playerCoordinate ? data.playerCoordinate : {}
    }

    preload() {
        this.load.image('background', 'images/sky.png')
        this.load.image('tile', 'images/tile.png')
        this.load.spritesheet('numbers', 'images/numbers.png',
            { frameWidth: 131, frameHeight: 71.25 })
        this.load.spritesheet('player', 'images/player.png',
            { frameWidth: 32, frameHeight: 32, startFrame: 6, endFrame: 8 })
        this.load.spritesheet('enemy', 'images/enemy.png',
            { frameWidth: 32, frameHeight: 32, startFrame: 3, endFrame: 5 })
        this.load.audio('correct', 'sfx/correct.wav')
        this.load.audio('wrong', 'sfx/loselife.wav')
        this.load.audio('gameover', 'sfx/gameover.wav')
        this.load.audio('math', 'sfx/mathbacksound.mp3')
    }

    create() {
        this.backsound = this.sound.add('math')
        var soundConfig = {
            loop: true
        }
        this.backsound.play(soundConfig)
        this.add.image(this.gameHalfWidth, this.gameHalfHeight, 'background').setScale(2)
        const tile = this.physics.add.staticImage(this.gameHalfWidth, this.gameHalfHeight - 40, 'tile')

        this.player = this.physics.add.sprite(
            this.gameHalfWidth - 150,
            this.gameHalfHeight - 200,
            'player', 6).setScale(2)

        this.physics.add.collider(this.player, tile)

        this.enemy = this.physics.add.sprite(
            this.gameHalfWidth + 150,
            this.gameHalfHeight - 200,
            'enemy', 3).setScale(2)
        this.physics.add.collider(this.enemy, tile)

        this.resultText = this.add.text(this.gameHalfWidth, 200, '0',
            // @ts-ignore
            { fontSize: '32px', fill: '#000' })
        this.questionText = this.add.text(this.gameHalfWidth, 100, '0',
            // @ts-ignore
            { fontSize: '32px', fill: '#000' })

        this.createButtons()
        this.input.on('gameobjectdown', this.addNumber, this)
        this.generateQuestion()
        this.scoreLabel = this.createScoreLabel(26, 16, this.score ? this.score : 0)
        this.lifeLabel = this.createLifeLabel(26, 36, this.lifeLabel ? this.lifeLabel : 3)

        console.log(JSON.stringify(this.enemyArray) + "soal")

        this.timerLabel = this.add.text(this.gameHalfWidth, 16, null).setDepth(5)

        this.timedEvent = this.time.addEvent({
            delay: 1000,
            callback: this.gameOver,
            callbackScope: this,
            loop: true
        })
    }

    update(time) {
        if (this.startGame = true) {
            this.timerLabel.setStyle({
                fontSize: '24px',
                fill: '#000',
                fontStyle: 'bold',
                align: 'center'
                // @ts-ignore
            }).setText(this.countdownTimer)
        }
    }

    createButtons() {
        const startPositionY = this.scale.height - 300
        const widthDifference = 131
        const heightDifference = 71.25

        this.button2 = this.add.image(this.gameHalfWidth, startPositionY, 'numbers', 1)
            .setInteractive().setData('value', 2)
        this.button5 = this.add.image(this.gameHalfWidth, this.button2.y + heightDifference, 'numbers', 4)
            .setInteractive().setData('value', 5)
        this.button8 = this.add.image(this.gameHalfWidth, this.button5.y + heightDifference, 'numbers', 7)
            .setInteractive().setData('value', 8)
        this.button0 = this.add.image(this.gameHalfWidth, this.button8.y + heightDifference, 'numbers', 10)
            .setInteractive().setData('value', 0)
        this.button1 = this.add.image(this.button2.x - widthDifference, startPositionY, 'numbers', 0)
            .setInteractive().setData('value', 1)
        this.button4 = this.add.image(this.button5.x - widthDifference, this.button1.y + heightDifference, 'numbers', 3)
            .setInteractive().setData('value', 4)
        this.button7 = this.add.image(this.button8.x - widthDifference, this.button4.y + heightDifference, 'numbers', 6)
            .setInteractive().setData('value', 7)
        this.buttonDel = this.add.image(this.button0.x - widthDifference, this.button7.y + heightDifference, 'numbers', 9)
            .setInteractive().setData('value', 'del')
        this.button3 = this.add.image(this.button2.x + widthDifference, startPositionY, 'numbers', 2)
            .setInteractive().setData('value', 3)
        this.button6 = this.add.image(this.button5.x + widthDifference, this.button3.y + heightDifference, 'numbers', 5)
            .setInteractive().setData('value', 6)
        this.button9 = this.add.image(this.button8.x + widthDifference, this.button6.y + heightDifference, 'numbers', 8)
            .setInteractive().setData('value', 9)
        this.buttonOk = this.add.image(this.button0.x + widthDifference, this.button9.y + heightDifference, 'numbers', 11)
            .setInteractive().setData('value', 'ok')
    }

    addNumber(pointer, object, event) {
        let value = object.getData('value')
        if (isNaN(value)) {
            if (value == 'del') {
                this.numberArray.pop()
                if (this.numberArray.length < 1) {
                    this.numberArray[0] = 0
                }
            }
            if (value == 'ok') {
                this.checkAnswer()
                this.numberArray = []
                this.numberArray[0] = 0
            }
        }
        else {
            if (this.numberArray.length == 1 &&
                this.numberArray[0] == 0) {
                this.numberArray[0] = value
            } else {
                if (this.numberArray.length < 10) {
                    this.numberArray.push(value)
                }
            }
        }

        this.number = parseInt(this.numberArray.join(''))

        // @ts-ignore
        this.resultText.setText(this.number)
        const textHalfWidth = this.resultText.width * 0.5
        this.resultText.setX(this.gameHalfWidth - textHalfWidth)
        event.stopPropagation()
    }

    getOperator() {
        const operator = ['+', '-', 'x', ':']
        return operator[Phaser.Math.Between(0, operator.length - 1)]
    }

    generateQuestion() {
        let numberA = Phaser.Math.Between(0, 50)
        let numberB = Phaser.Math.Between(0, 50)
        let operator = this.getOperator()

        if (operator === '+') {
            this.question[0] = `${numberA} + ${numberB}`
            this.question[1] = numberA + numberB
        }

        if (operator === '-') {
            if (numberB > numberA) {
                this.question[0] = `${numberB} - ${numberA}`
                this.question[1] = numberB - numberA
            } else {
                this.question[0] = `${numberA} - ${numberB}`
                this.question[1] = numberA - numberB
            }
        }

        if (operator === 'x') {
            this.question[0] = `${numberA} x ${numberB}`
            this.question[1] = numberA * numberB
        }

        if (operator === ':') {
            do {
                numberA = Phaser.Math.Between(0, 50)
                numberB = Phaser.Math.Between(0, 50)
            }
            while (!Number.isInteger(numberA / numberB))

            this.question[0] = `${numberA} : ${numberB}`
            this.question[1] = numberA / numberB
        }

        this.questionText.setText(this.question[0])
        const textHalfWidth = this.questionText.width * 0.5
        this.questionText.setX(this.gameHalfWidth - textHalfWidth)



    }

    checkAnswer() {
        if (this.number == this.question[1]) {
            this.correctAnswer = true
            this.scoreLabel.add(10)
            this.sound.stopAll()
            this.sound.play('correct')
            this.scene.start('reo-mathematics-scene', {
                score: this.scoreLabel.getScore(), lifeLabel: this.lifeLabel.getLife(),
                enemyArray: this.enemyArray, playerCoordinate: this.playerCoordinate
            })

        }
        else {
            this.correctAnswer = false
            this.lifeLabel.subtract(1)
            if (this.lifeLabel.getLife() == 0) {
                this.sound.stopAll()
                this.sound.play('gameover')
                this.scene.start('game-over-scene',
                    { score: this.scoreLabel.getScore() })
            }
            else {
                this.sound.stopAll()
                this.sound.play('wrong')
                this.scene.start('reo-mathematics-scene', {
                    score: this.scoreLabel.getScore(), lifeLabel: this.lifeLabel.getLife(),
                    enemyArray: this.enemyArray, playerCoordinate: this.playerCoordinate
                })
            }

        }
    }

    createScoreLabel(x, y, score) {
        const style = { fontSize: '24px', fill: '#000', fontStyle: 'bold' }
        const label = new ScoreLabel(this, x, y, score, style).setDepth(1)

        this.add.existing(label)
        return label
    }

    createLifeLabel(x, y, life) {
        const style = { fontSize: '24px', fill: '#000' }
        const label = new LifeLabel(this, x, y, life, style).setDepth(1)

        this.add.existing(label)

        return label
    }

    gameOver() {
        this.countdownTimer -= 1
        if (this.countdownTimer < 1) {
            this.sound.stopAll()
            this.lifeLabel.subtract(1)
            this.scene.start('reo-mathematics-scene', {
                score: this.scoreLabel.getScore(), lifeLabel: this.lifeLabel.getLife(),
                enemyArray: this.enemyArray
            })
        }

    }

}